import { defineSlotRecipe } from "@chakra-ui/react";

export const tabsSlotRecipe = defineSlotRecipe({
  className: "chakra-tabs",
  slots: ["root", "trigger", "list", "content", "contentGroup", "indicator"],
  variants: {
    variant: {
      segment: {
        content: {
          _horizontal: {
            pt: "6",
          },
        },
        indicator: {
          bg: "bg",
          borderRadius: "2xl",
          shadow: "sm",
        },
        list: {
          bg: "bg.subtle",
          borderRadius: "2xl",
          borderWidth: "1px",
          boxShadow: "inset",
          display: "flex",
        },
        trigger: {
          "&[data-selected][data-ssr]": {
            bg: "bg",
            borderRadius: "l2",
            shadow: "sm",
          },
          _selected: {
            color: "fg",
          },
          borderRadius: "l2",
          color: "fg.muted",
          flex: "1",
          justifyContent: "center",
        },
      },
    },
  },
});
